import React from "react";
import { ColumnData, RowData, Table } from "@vwpfs/mary-air-lib/components/air/06-molecules/Table";
import { ThemeShadowSizes, ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";


interface OwnProps {
    tableColumnData: ColumnData[];
    tablerowData: RowData[];
    hasActions?: boolean;
    noPadding?: boolean;
}

type Props = OwnProps;

export const Summary: React.FC<Props> = (props) => (
    <Div theme={!!props.noPadding ? {} : { padding: { "": { b: 2, t: 2 }, "sm": { b: 3, t: 3 } } }}>
        <Div theme={{ shadow: ThemeShadowSizes.TINY, palette: ThemePalette.CONTRAST_PRIMARY }}>
            <Table
                hasActions={props.hasActions}
                data={{
                    columns: props.tableColumnData,
                    rows: props.tablerowData,
                }}
            />
        </Div>
    </Div>
);
